import React, { useEffect } from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { SVGICONS } from "config";
import { AppleIcon, GooglePay, PlusIconn } from "icons";
import { StoreAction, AppAction, PaymentMethodAction, PaymentCardsAction } from "store/actions";
import { useDetectBrowserWallets } from "hooks";
import C from "Constants";
import { useLang } from "hooks";
import useBrandLosgisticIntegrations from "hooks/useBrandLosgisticIntegrations";
import CardMachine from "icons/CardMachine";
import CashMachine from "icons/CashMachine";
import { getCreditCardObjByOrderType } from "utils/Utils";
import useScrollToBottomPaymentWidget from "hooks/useScrollToBottomPaymentWidget";
import { HeadingText } from "components/TextTranslationContainer";


const SortPaymentOptions = (paymentOptions) => {
  if (!paymentOptions || paymentOptions?.length <= 0) return [];
  const options = [...paymentOptions];
  const creditCard = options?.find(
    (paymentOption) => paymentOption.paymentType === C.CREDIT_CARD
  );
  if (creditCard) {
    const creditCardIndex = options?.indexOf(creditCard);
    options.splice(creditCardIndex, 1);
    options.unshift(creditCard);
  }
  return options;
};

const CardOption = ({ onClick = () => {}, icon, label, radioChecked }) => {
  return (
    <div className="flex justify-between items-center"  onClick={onClick}>
        <div className="flex items-center gap-3">
          {icon && <span>{icon}</span>}
          {typeof label === "string" ? <span className="text-16x font-medium text-dark-blue-900">{t(label)}</span> : label}
        </div>
        <div className="flex">
          <span className="inline-flex w-6 h-6">
            <input type="radio" name="Select Type" className="hidden" />
            <span className="w-6 h-6 inline-flex ">
              {radioChecked ? (
                <SVGICONS.RadioCheck color="text-brand-base-primary" />
              ) : (
                <SVGICONS.RadioUnCheck color="text-brand-base-primary" />
              )}
            </span>
          </span>
        </div>
      </div>
  );
};

const CheckoutPaymentMethod = ({ paymentOptions, children,  setSelectedOption=()=>{} , setcardProcessing , handleSuceessOrderRoute=()=>{} , resetSelectedTypeProps={},
isPaymentConfirmationPage=false }) => {
  const dispatch = useDispatch();

  const { selectedPaymentType } = useSelector(
    (state) => state.PaymentMethodReducer
  );

  const scrollToBottom = useScrollToBottomPaymentWidget(selectedPaymentType);
  const { currentLang } = useLang();
  const { integrationsByName } = useBrandLosgisticIntegrations();
  const supportedBrowserWallets = useDetectBrowserWallets();
  const { selectedPayment, selectedStore } = useSelector(
    (state) => state.store
  );
  
  const { orderType } = useSelector((state) => state.AppReducer);

  useEffect(() => {
    localStorage.removeItem("activePaymentMethod");
    localStorage.removeItem("currentEnvironment");
    resetPaymentType();
  }, []);

  const resetPaymentType = () => {
    if(isPaymentConfirmationPage){
      return;
    }
    dispatch(
      PaymentCardsAction.setstripeSelectedCard({
        cardInfo: {},
        isStoredCard: false,
      })
    );

    dispatch(PaymentCardsAction.setstripePaymentCards([]));
    dispatch(StoreAction.setSelectedPaymentMethod(null));
    dispatch(PaymentMethodAction.setSelectedPaymentType(null));
    setSelectedOption(null);
    dispatch(AppAction.setCurrentPaymentMethod(null));
  };

  const setPaymentMEthod = (payment, type) => {
    dispatch(AppAction.setCurrentPaymentMethod(null));
    dispatch(StoreAction.setSelectedPaymentMethod(payment));
    dispatch(PaymentMethodAction.setSelectedPaymentType(type));
    setSelectedOption(type);
    dispatch(PaymentCardsAction.resetSelectedCards());
  };

  const IsONlinePaymentEnabled = (paymentOptions) => {
    if (!paymentOptions || paymentOptions?.length <= 0) return null;
    if (!GetcardText()) return null;

    const creditCard = paymentOptions?.find(
      (paymentOption) => paymentOption.paymentType === C.CREDIT_CARD
    );
    if (creditCard) {
      return creditCard;
    } else return null;
  };

  const GetcardText = () => {
    if(integrationsByName[C.AFS_PAYMENT]) return t("AFS CARD LABEL");
    if (integrationsByName[C.STRIPE] || integrationsByName[C.CHECKOUT_DOT_COM] || integrationsByName[C.PAYBY] || integrationsByName[C.AFS_PAYMENT])
      return t("Add new card");
    if (integrationsByName[C.TELR]) return t("Pay with card");
    return null;
  };

  const paymentTypeMap = {
    [C.CREDIT_CARD]: {
      icon: <PlusIconn color="text-brand-base-primary" />,
      label: () => GetcardText(),
    },
    CASH: {
      icon: <CashMachine color="text-brand-base-primary"/>,
      label: (method, lang) => method?.[lang ?? "EN"].name,
    },
    CARD_MACHINE: {
      icon: <CardMachine color="text-brand-base-primary"/>,
      label: (method, lang) => method?.[lang ?? "EN"].name,
    },
  };

  useEffect(() => {
    if(resetSelectedTypeProps?.selectedPaymentType){
      setPaymentMEthod(selectedPayment, null);
      resetSelectedTypeProps?.resetSelectedType();
    }
  }, [resetSelectedTypeProps?.selectedPaymentType]);

  return (
    <>
      <div className="flex flex-col gap-6">
        <HeadingText text="Choose Payment Method" />
        {/* apple pay handling by Zeeshan Ahmad */}
       {IsONlinePaymentEnabled(paymentOptions) &&
          integrationsByName[C.STRIPE] && ( 
            <>
              {supportedBrowserWallets?.applePay && (
                <CardOption
                  onClick={() => {
                    setPaymentMEthod(
                      getCreditCardObjByOrderType(orderType, selectedStore),
                      C.WALLET.APPLE_PAY
                    );
                  }}
                  label="Apple pay"
                  icon={<AppleIcon color="text-brand-base-primary" />}
                  radioChecked={
                    selectedPayment?.paymentType === C.CREDIT_CARD &&
                    selectedPaymentType === C.WALLET.APPLE_PAY
                  }
                />
               )}
              {supportedBrowserWallets?.googlePay && ( 
                <CardOption
                  onClick={() => {
                    setPaymentMEthod(
                      getCreditCardObjByOrderType(orderType, selectedStore),
                      C.WALLET.GOOGLE_PAY
                    );
                  }}
                  label={"Google Pay"}
                  icon={<GooglePay color="text-brand-base-primary" />}
                  radioChecked={
                    selectedPayment?.paymentType === C.CREDIT_CARD &&
                    selectedPaymentType === C.WALLET.GOOGLE_PAY
                  }
                />
                )}
            </>
        )}

        {IsONlinePaymentEnabled(paymentOptions) &&
          children &&
          children?.length >= 1 &&
          children[0]}

        {SortPaymentOptions(paymentOptions)?.map((paymentMethod, i) => {
          const type = paymentMethod?.paymentType;
          const isCreditCard = type === C.CREDIT_CARD;
          if ((isCreditCard && !GetcardText()) || type === C.PAY_LATER)
            return null;
          const { icon, label } = paymentTypeMap[type] || {};

          return (
            <CardOption
              key={i}
              onClick={() => {
                setPaymentMEthod(
                  paymentMethod,
                  isCreditCard ? C.WALLET.NEW_CARD : C.WALLET.CASH
                );
                if (isCreditCard) scrollToBottom();
              }}
              label={
                typeof label === "function"
                  ? label(paymentMethod, currentLang)
                  : null
              }
              icon={icon}
              radioChecked={
                (selectedPaymentType === C.WALLET.CASH &&
                  type !== C.CREDIT_CARD &&
                  selectedPayment?._id === paymentMethod?._id) ||
                (selectedPayment?.paymentType === C.CREDIT_CARD &&
                  selectedPaymentType === C.WALLET.NEW_CARD &&
                  type === C.CREDIT_CARD)
              }
            />
          );
        })}
        {children && children?.length >= 2 && children[1]}
      </div>
      <div id="payment-methods"></div>
      {/* <dialog id="payment_result_dialog">
        <p id="payment_result_message"></p>
        <button onclick="document.getElementById('payment_result_dialog').close()">
          Close
        </button>
      </dialog> */}
    </>
  );
};

export default CheckoutPaymentMethod;
